import React from "react";

function PageNotFound(props) {
  return (
    <div>
      <section>
        <p>Page not found</p>
      </section>
    </div>
  );
}

export default PageNotFound;
